import {API_MODES, fetchApiMode, fetchFrostbyteTicketHeaders} from "../index";

const fetch = require('node-fetch');

function getURL() {
  switch (fetchApiMode()) {
    default:
      return "http://127.0.0.1:6969/api/";
    case API_MODES.LOCAL_ANDROID:
      return "http://10.0.2.2:6969/api/";
    case API_MODES.LIVE:
      return "https://api.dripdrinks.co/";
    case API_MODES.STAGING:
      return "https://bapi.dripos.com/";
    case API_MODES.QE:
      return "https://aapi.dripos.com/";
    case API_MODES.TESTING:
      return "https://testapi.dripos.com/";
  }
}

export function getShortURL() {
  switch (fetchApiMode()) {
    default:
      return "http://127.0.0.1:6969/";
    case API_MODES.LIVE:
      return "https://api.dripdrinks.co/";
    case API_MODES.STAGING:
      return "https://bapi.dripos.com/";
    case API_MODES.QE:
      return "https://aapi.dripos.com/";
    case API_MODES.TESTING:
      return "https://testapi.dripos.com/";
  }
}

export async function request(endpoint, method, body) {
  return new Promise((resolve, reject) => {
    let headers = {
      "Accept": "application/json",
      "Content-Type": "application/json",
      ...fetchFrostbyteTicketHeaders()
    };

    let params = "";
    if (method === "GET" && body) {
      params =
        "?" +
        Object.keys(body)
          .map((item) => {
            return item + "=" + encodeURIComponent(body[item]);
          })
          .join("&");

      body = null;
    }

    if (body !== null) {
      fetch(getURL() + endpoint, {
        method: method,
        headers: headers,
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson["success"]) {
            resolve(responseJson.data);
          } else {
            reject(responseJson);
          }
        })
        .catch((error) => {
          reject(error);
        });
    } else {
      fetch(getURL() + endpoint + params, {
        method: method,
        headers: headers,
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson["success"]) {
            resolve(responseJson.data);
          } else {
            reject(responseJson);
          }
        })
        .catch((error) => {
          reject(JSON.stringify(error.message));
        }).then((data) => {
      });
    }
  });
}
